var _toConsumableArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Created by Samuel on 6/4/2016.
 * Simple wrapper functions to produce shorter UUIDs for cookies, maybe everything?
 */
var _require = require('uuid'),
    uuidv4 = _require.v4;

var anyBase = require('any-base');

var flickrBase58 = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ';
var cookieBase90 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~";
var baseOptions = {
  consistentLength: true
}; // A default generator, instantiated only if used.

var toFlickr;
/**
 * Takes a UUID, strips the dashes, and translates.
 * @param {string} longId
 * @param {function(string)} translator
 * @param {Object} [paddingParams]
 * @returns {string}
 */

var shortenUUID = function shortenUUID(longId, translator, paddingParams) {
  var translated = translator(longId.toLowerCase().replace(/-/g, ''));
  if (!paddingParams || !paddingParams.consistentLength) return translated;
  return translated.padStart(paddingParams.shortIdLength, paddingParams.paddingChar);
};
/**
 * Translate back to hex and turn back into UUID format, with dashes
 * @param {string} shortId
 * @param {function(string)} translator
 * @returns {string}
 */


var enlargeUUID = function enlargeUUID(shortId, translator) {
  var uu1 = translator(shortId).padStart(32, '0'); // Join the zero padding and the UUID and then slice it up with match

  var m = uu1.match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/); // Accumulate the matches and join them.

  return [m[1], m[2], m[3], m[4], m[5]].join('-');
}; // Calculate length for the shortened ID


var getShortIdLength = function getShortIdLength(alphabetLength) {
  return Math.ceil(Math.log(Math.pow(2, 128)) / Math.log(alphabetLength));
};

module.exports = function () {
  /**
   * @param {string} toAlphabet - Defaults to flickrBase58 if not provided
   * @param {Object} [options]
   *
   * @returns {{new: (function()),
   *  uuid: (function()),
   *  fromUUID: (function(string)),
   *  toUUID: (function(string)),
   *  alphabet: (string)}}
   */
  var makeConvertor = function makeConvertor(toAlphabet, options) {
    // Default to Flickr 58
    var useAlphabet = toAlphabet || flickrBase58; // Default to baseOptions

    var selectedOptions = _objectSpread(_objectSpread({}, baseOptions), options); // Check alphabet for duplicate entries


    if (_toConsumableArray(new Set(Array.from(useAlphabet))).length !== useAlphabet.length) {
      throw new Error('The provided Alphabet has duplicate characters resulting in unreliable results');
    }

    var shortIdLength = getShortIdLength(useAlphabet.length); // Padding Params

    var paddingParams = {
      shortIdLength: shortIdLength,
      consistentLength: selectedOptions.consistentLength,
      paddingChar: useAlphabet[0]
    }; // UUIDs are in hex, so we translate to and from.

    var fromHex = anyBase(anyBase.HEX, useAlphabet);
    var toHex = anyBase(useAlphabet, anyBase.HEX);

    var generate = function generate() {
      return shortenUUID(uuidv4(), fromHex, paddingParams);
    };

    var translator = {
      new: generate,
      generate: generate,
      uuid: uuidv4,
      fromUUID: function fromUUID(uuid) {
        return shortenUUID(uuid, fromHex, paddingParams);
      },
      toUUID: function toUUID(shortUuid) {
        return enlargeUUID(shortUuid, toHex);
      },
      alphabet: useAlphabet,
      maxLength: shortIdLength
    };
    Object.freeze(translator);
    return translator;
  }; // Expose the constants for other purposes.


  makeConvertor.constants = {
    flickrBase58: flickrBase58,
    cookieBase90: cookieBase90
  }; // Expose the generic v4 UUID generator for convenience

  makeConvertor.uuid = uuidv4; // Provide a generic generator

  makeConvertor.generate = function () {
    if (!toFlickr) {
      // Generate on first use;
      toFlickr = makeConvertor(flickrBase58).generate;
    }

    return toFlickr();
  };

  return makeConvertor;
}();